import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAgencies from "../../data/useAgencies";
import LoadingWheel from "../../components/Shared/LoadingWheel";
import Breadcrumbs from "../../components/Shared/Breadcrumbs";
import { Link } from "react-router-dom";
import useMeta from "../../data/useMeta";

export default function SocialPageSelector() {
  const { agencyId } = useParams();
  const { agencies } = useAgencies();
  const { metaPageConfigs } = useMeta(agencyId);
  const [agency, setAgency] = useState(null);
  const [metaPages, setMetaPages] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadAgency = useCallback(() => {
    if (!agencies.isLoading && agencies.data.length > 0 && !metaPageConfigs.isLoading && metaPageConfigs.data) {
      let agency = agencies.data.find((a) => a.id === agencyId);

      setMetaPages(metaPageConfigs.data.data);
      setAgency(agency);
      setLoading(false);
    }
  }, [agencies.isLoading, agencies.data, metaPageConfigs.isLoading, metaPageConfigs.data, agencyId]);

  useEffect(() => {
    document.title = "EstateTrack Admin | Social Tool";
    setLoading(true);
    loadAgency();
  }, [agencies, agencyId, loadAgency]);

  const pages = [
    { to: "/admin/agencies", label: "Agencies", current: false },
    { to: `/admin/agencies/${agencyId}`, label: agencyId && agency ? `${agency.name}` : "", current: false },
    {
      to: "",
      label: "Pages",
      current: true,
    },
  ];

  if (loading) {
    return (
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="h-80 max-w-7xl flex items-center justify-center">
          <LoadingWheel width="w-10" height="h-10" />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="px-4 sm:px-6 lg:px-8">
        <Breadcrumbs pages={pages} />
        <div className="sm:flex-auto my-4">
          <h3 className="text-xl font-semibold text-gray-900">
            {agency && `${agency.name} Social Pages`}
          </h3>
          <p className="mt-2 text-sm text-gray-700">
            {agency && `View and edit ${agency.name}'s social post schedules and content`}
          </p>
        </div>

        <div className="bg-white rounded-lg shadow overflow-hidden">

          <div className="h-full py-6 px-4 sm:p-6 lg:pb-8">
            <h1 className="text-lg">Choose a Page to manage</h1>

            {metaPages && metaPages.length > 0 ? (
              <div className="grid grid-cols-2 gap-4 mt-4">
                {metaPages.map((page) => (
                  <Link to={`/admin/agencies/${agencyId}/social-posts/${page.id}`} key={page.id} className="bg-gray-100 hover:bg-gray-200 shadow p-4 rounded-lg">
                    <h2 className="text-lg">{page.pageName}</h2>
                    <p className="text-sm text-gray-600">Facebook Page ID: {page.pageId}</p>
                    {page.instagramUserId && (
                      <p className="text-sm text-gray-600">Instagram User ID: {page.instagramUserId}</p>
                    )}
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center mt-4">
                <p className="text-gray-600">No pages found</p>
              </div>
            )}
          </div>

        </div>
      </div>
    </>
  );

}